import { render } from "./About.vue?vue&type=template&id=e93d9232&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=e93d9232&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e93d9232"]])

export default __exports__